import { render, staticRenderFns } from "./ListSchool.vue?vue&type=template&id=05b34966&"
import script from "./ListSchool.vue?vue&type=script&lang=js&"
export * from "./ListSchool.vue?vue&type=script&lang=js&"
import style0 from "./ListSchool.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports